import { TranslateService } from '@ngx-translate/core';
import { Injectable, inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { NotificationType } from '@core/enums/notification-type.enum';
import { Notification } from '@core/interfaces/notifications.interface';
import { ToastMessageOptions } from 'primeng/api';

@Injectable()
export class NotificationService {
  private translateService = inject(TranslateService);

  private $notificationToastrSubject = new Subject<Notification>();

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  listenNotificationToastr(): Observable<Notification> {
    return this.$notificationToastrSubject.asObservable();
  }

  info(description: string, title?: string, options?: ToastMessageOptions): void {
    this.$notificationToastrSubject.next({
      severity: NotificationType.INFO,
      summary: this.translateService.instant(title),
      detail: description ? this.translateService.instant(description) : '',
      options: options,
    });
  }

  success(description: string, title?: string, options?: ToastMessageOptions): void {
    this.$notificationToastrSubject.next({
      severity: NotificationType.SUCCESS,
      summary: this.translateService.instant(title),
      detail: description ? this.translateService.instant(description) : '',
      options: options,
    });
  }

  warning(description: string, title?: string, options?: ToastMessageOptions): void {
    this.$notificationToastrSubject.next({
      severity: NotificationType.WARNING,
      summary: this.translateService.instant(title),
      detail: description ? this.translateService.instant(description) : '',
      options: options,
    });
  }

  error(description: string, title?: string, options?: ToastMessageOptions): void {
    this.$notificationToastrSubject.next({
      severity: NotificationType.ERROR,
      summary: this.translateService.instant(title),
      detail: description ? this.translateService.instant(description) : '',
      life: 5000,
      options: options,
    });
  }
}
